export enum USER_TYPES {
  CANDIDATE = 'candidate',
  MEMBER = 'member',
  COMPANYSPACEOWNER = 'company-space-owner',
  ADMIN = 'admin',
  HIREHAC_ADMIN = 'hirehac-admin',
}
